import React, { useState, useEffect } from "react";
import { Card, Tree, Form, Input, Button, message, Spin, Empty } from "antd";
import { getMenuApi, updateMenuApi } from "./service";

const MenuUpdate = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  // 菜单原始数据（menulist），用于根据 key 查找节点
  const [menuList, setMenuList] = useState([]);
  // 树结构数据
  const [treeData, setTreeData] = useState([]);
  // 当前选中的菜单节点
  const [selectedKey, setSelectedKey] = useState(null);

  // 把接口返回的 menulist 转成 antd Tree 需要的 treeData 结构
  const buildTreeData = (list) => {
    if (!Array.isArray(list)) return [];
    return list.map((item) => {
      var node = {
        key: String(item.menuid),
        title: item.menuname,
        menuid: item.menuid,
        menuname: item.menuname,
        url: item.url || "",
      };
      if (item.children && item.children.length > 0) {
        node.children = buildTreeData(item.children);
      }
      return node;
    });
  };

  // 在扁平化的节点 map 中查找（递归）
  const findNode = (list, key) => {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].menuid) === key) return list[i];
      if (list[i].children && list[i].children.length) {
        var found = findNode(list[i].children, key);
        if (found) return found;
      }
    }
    return null;
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await getMenuApi();
      if (res && res.status === 200 && res.data && res.data.menulist) {
        var list = res.data.menulist;
        setMenuList(list);
        setTreeData(buildTreeData(list));
      }
    } catch (err) {
      // axiosPost 内部已处理错误提示
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // 选中菜单节点时，把当前的 menuname 和 url 回填到表单
  const onSelect = (keys) => {
    if (!keys || keys.length === 0) {
      setSelectedKey(null);
      form.resetFields();
      return;
    }
    var key = keys[0];
    setSelectedKey(key);
    var node = findNode(menuList, key);
    if (node) {
      form.setFieldsValue({
        menu_name: node.menuname || "",
        url: node.url || "",
      });
    }
  };

  const onFinish = async () => {
    if (!selectedKey) {
      message.warning("请先选择一个菜单");
      return;
    }
    var node = findNode(menuList, selectedKey);
    if (!node) {
      message.warning("菜单数据异常，请重新选择");
      return;
    }
    var values = form.getFieldsValue();
    setSubmitting(true);
    try {
      const res = await updateMenuApi({
        id: node.menuid,
        menu_name: values.menu_name,
        url: values.url,
      });
      if (res && res.data == 0) {
        message.success("菜单更新成功");
        // 更新本地数据，保持树和表单同步
        node.menuname = values.menu_name;
        node.url = values.url;
        setTreeData(buildTreeData(menuList));
      }
    } catch (err) {
      // ajaxApi 内部已处理错误提示
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="菜单名称/URL 更新">
        <Spin spinning={loading}>
          {treeData.length === 0 && !loading ? (
            <Empty description="暂无菜单数据" />
          ) : (
            <div style={{ display: "flex", gap: 24 }}>
              {/* 左侧：菜单树 */}
              <Card
                size="small"
                title="菜单列表（点击选中要修改的菜单）"
                style={{ width: 360, flexShrink: 0 }}
                bodyStyle={{ maxHeight: 600, overflow: "auto" }}
              >
                <Tree
                  treeData={treeData}
                  defaultExpandAll
                  selectedKeys={selectedKey ? [selectedKey] : []}
                  onSelect={onSelect}
                />
              </Card>

              {/* 右侧：编辑表单 */}
              <Card
                size="small"
                title="菜单信息"
                style={{ flex: 1, maxWidth: 520 }}
              >
                {selectedKey ? (
                  <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item label="菜单ID">
                      <Input value={selectedKey} disabled />
                    </Form.Item>
                    <Form.Item
                      name="menu_name"
                      label="菜单名称"
                      rules={[{ required: true, message: "请输入菜单名称" }]}
                    >
                      <Input placeholder="请输入菜单名称" />
                    </Form.Item>
                    <Form.Item
                      name="url"
                      label="URL"
                      rules={[{ required: true, message: "请输入URL" }]}
                    >
                      <Input placeholder="请输入URL" />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={submitting}
                      >
                        提交更新
                      </Button>
                    </Form.Item>
                  </Form>
                ) : (
                  <Empty
                    description="请先在左侧选择一个菜单"
                    style={{ marginTop: 80 }}
                  />
                )}
              </Card>
            </div>
          )}
        </Spin>
      </Card>
    </div>
  );
};

export default MenuUpdate;



// WEBPACK FOOTER //
// ./src/pages/menuUpdate/index.js